
$(function(){

  $('.matchHeight').matchHeight();

  //SP時のみ高さを揃えたい時
  var spHeight = window.matchMedia('(max-width: 550px)');

  function checkMatchHeight(e) {
    if (e.matches) {
      $('.matchHeight_s').matchHeight();
    } else {
      $('.matchHeight_s').matchHeight({remove :true});
      $('.matchHeight_s').css('height', '')
    }
  }
  checkMatchHeight(spHeight);
  spHeight.addEventListener('change', checkMatchHeight);

  // 550px以下では、リサイズのたびに高さを再計算
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      if (spHeight.matches) {
        $('.matchHeight_s').matchHeight({ remove: true });
        checkMatchHeight(spHeight);
      }
    }, 500);
  });

  //メニューのアコーディオン　開閉
  accordion();

  //トップへ戻るボタン
  $(window).scroll(function(){
    if($(window).scrollTop() > 1100) {
      $('#banner').addClass('active');
    } else {
      $('#banner').removeClass('active');
    }
  });

});


//スクロール調整
$(function () {

  $('html, body').on('click', 'a[href^="#"]', function () {
    var href = $(this).attr('href');
    if (href === '#') {
      return;
    }
    $('html, body').animate({
      scrollTop: $(href).offset().top
    }, 500, 'swing');
    return false;
  });
});

//メニューのアコーディオン　開閉
function accordion() {
	$('.js-accordion').click(function () {
		$(this).next().toggleClass("is-show");
	});
}

// デバイスタイプを判別（例：画面幅）
const isMobile = window.matchMedia("(max-width: 768px)").matches;

// aタグを全て取得
const links = document.querySelectorAll('a[data-target]');

// リンクのtarget属性を調整
links.forEach(link => {
  const target = link.getAttribute('data-target');

  // SPの場合はtarget属性を"_self"に設定
  if (isMobile) {
    link.setAttribute('target', "_self");
  } else {
    link.setAttribute('target', target); // PCの場合は元のtarget属性を維持
  }
});